const closePopUpByKey = (closePopup) => {
  window.addEventListener('keyup', (e) => {
    if (e.keyCode == 27) {
      closePopup()
    }
  })
}

export default closePopUpByKey
